import FinalizeJobsNoLongerReadyChoiceEnum from './FinalizeJobsNoLongerReadyChoiceEnum';

const FinalizeJobsNoLongerReadyChoiceOptionsArray = [
  { label: 'Remove them from the invoice, then finalize', value: FinalizeJobsNoLongerReadyChoiceEnum.Remove },
  { label: 'Keep them on the invoice', value: FinalizeJobsNoLongerReadyChoiceEnum.Keep },
];

export default FinalizeJobsNoLongerReadyChoiceOptionsArray;
